import(/* webpackMode: "eager" */ "/app/apps/location-app-router/app/global-error.tsx");
